import * as React from 'react'

import { ExperimentsContext, ExperimentsContextData } from '../../context'
import { Experiment as ExperimentType, Variant as VariantType } from '../../types'

export interface Props {
  children: React.ReactNode
  variant: VariantType
  experiment: ExperimentType
}

const Variant: React.SFC<Props> = ({ children, experiment: applicableExperiment, variant }) => (
  <ExperimentsContext.Consumer>
    {({ selectedVariantId, experiment }: ExperimentsContextData) =>
      selectedVariantId === variant.id && applicableExperiment.id === experiment?.id ? children : null
    }
  </ExperimentsContext.Consumer>
)

export default Variant
